import { createStreamTimerRegistry } from './streamSession/streamTimerRegistry'

/**
 * Binds timers/intervals to an AbortSignal so navigation, thread switch, or new sends
 * do not leave orphaned setInterval/setTimeout callbacks updating stale UI.
 */
export function createAssistantStreamSession(signal) {
  const { addTimeout, addInterval, dispose } = createStreamTimerRegistry(signal)
  return { addTimeout, addInterval, dispose, signal }
}
